import React from "react";
import PropTypes from "prop-types";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import styles from "./audio-magazine.m.css";
import { get } from "lodash";
import ResponsiveImageWithFallback from "../atoms/responsive-image-with-fallback";
import { generateImageSources, checkAppSlug } from "../utils/utils";
import { Link, WithHostUrl } from "@quintype/components";
import { LoadmoreAudiostories } from "../../api";

export class AudioMagazineCollectionListPage extends React.Component {
  constructor() {
    super();
    this.state = {
      filter: null,
      currentIndex: 0,
      action: false,
      hasMoreStories: false,
      offset: 0,
      limit: 10, // Added limit to state
      visibleItems: [], // Initialize as empty array
      totalStoryCount: 0,
      collectionName: "",
      loading: false // Added loading state
    };
    this.iframeWidgetsRef = React.createRef();
    this.pointtableWidgetsRef = React.createRef();
    this.StoryCollectionWidgetsRef = React.createRef();
  }

  componentDidMount() {
    const { data } = this.props;

    GA.registerPageView(this.props.pageType, {});
    WebEngage.registerPageView();
    DeepBI.registerPageView({ collection: this.props });
    PGAD.loadScript();

    const initialStories = get(data, ["collection", "items"], []);
    const totalStoryCount = get(data, ["collection", "total-count"], 0);
    const collectionName = get(data, ["collection", "slug"], "");

    this.setState({
      visibleItems: initialStories,
      totalStoryCount: totalStoryCount,
      offset: initialStories.length,
      hasMoreStories: initialStories.length < totalStoryCount,
      collectionName: collectionName
    });
  }

  audiomagazineCollectionPath = slug => {
    return `/vikatan-play/${slug}`;
  };

  audiomagazineBreadcrumb = slug => {
    return `/vikatan-play/collection/${slug}`;
  };

  fetchStories = async () => {
    const { offset, limit, collectionName } = this.state;
    const { data } = this.props;
    const collectionslug = get(data, ["collection", "slug"], "");
    const collectionId = collectionName || collectionslug;

    this.setState({ loading: true });

    try {
      const res = await LoadmoreAudiostories(collectionId, limit, offset);
      const newStories = res.items || [];

      this.setState(prevState => ({
        visibleItems: [...prevState.visibleItems, ...newStories],
        offset: prevState.offset + newStories.length,
        loading: false,
        hasMoreStories: prevState.visibleItems.length + newStories.length < prevState.totalStoryCount
      }));
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  handleLoadMore = () => {
    if (this.state.hasMoreStories && !this.state.loading) {
      this.fetchStories();
    }
  };

  render() {
    const { data } = this.props;
    const { loading, hasMoreStories, visibleItems } = this.state;

    const collectionsName = get(data, ["collection", "name"], "");
    const headline = get(data, ["collection", "name"], "");
    const LinkSlug = get(data, ["collection", "slug"], "");

    if (!(headline && LinkSlug)) {
      return null;
    }

    const checkSlug = checkAppSlug();
    let SourceLink = "";
    if (checkSlug) {
      SourceLink = this.audiomagazineCollectionPath(LinkSlug);
    }

    return (
      <React.Fragment>
        <div className={`js-story-main-container ${`${styles["base"]}`}`}>
          <div className={`${styles["collection-of-collection"]} container`}>
            <ul className={styles["collection-breadcrums"]} itemScope itemType="http://schema.org/BreadcrumbList">
              <li
                className={styles.breadcrumb}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <WithHostUrl>
                  {({ primaryHostUrl }) => (
                    <Link
                      aria-label="Vikatan"
                      href={primaryHostUrl ? primaryHostUrl + "/vikatan-play" + "/" : "/"}
                      itemprop="item"
                    >
                      <span itemProp="name">Home</span>
                    </Link>
                  )}
                </WithHostUrl>
                <span>/</span>
                <meta itemProp="position" content={1} />
              </li>
              {collectionsName && (
                <li
                  className={styles.breadcrumb}
                  itemProp="itemListElement"
                  itemScope
                  itemType="http://schema.org/ListItem"
                >
                  <Link
                    aria-label={`${"Navigate to "} ${this.audiomagazineBreadcrumb(LinkSlug)}`}
                    href={this.audiomagazineBreadcrumb(LinkSlug)}
                    itemprop="item"
                  >
                    <span itemProp="name">{collectionsName}</span>
                  </Link>
                  <meta itemProp="position" content={2} />
                </li>
              )}
            </ul>
            <h1 className={`${styles["collection-title"]}`}>{collectionsName}</h1>
            <div className={`${styles["collection-of-collection-grid"]}`}>
              {visibleItems.map((collection, index) => {
                const collectionName = collection.name;
                const collectionImage = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], "");
                const collectionImageMetaData = get(
                  collection,
                  ["metadata", "cover-image", "cover-image-metadata"],
                  {}
                );
                const collectionSlug = collection.slug;

                return (
                  <div key={index} className={`${styles["collection-container"]}`}>
                    <Link
                      className={`${styles["read-more-link"]}`}
                      href={this.audiomagazineCollectionPath(collectionSlug)}
                      externalLink={SourceLink}
                    >
                      {collectionImage && (
                        <div className={styles["cover-image"]}>
                          <ResponsiveImageWithFallback
                            className={styles["image-wrapper"]}
                            slug={collectionImage}
                            metadata={collectionImageMetaData}
                            alt={collectionName}
                            imgParams={{ auto: ["format", "compress"] }}
                            sources={generateImageSources(
                              { aspectRatio: [4, 3], screenWidthCoverage: 0.75 },
                              { aspectRatio: [4, 3], screenWidthCoverage: 0.3 }
                            )}
                          />
                        </div>
                      )}
                    </Link>
                  </div>
                );
              })}
            </div>
            {hasMoreStories && (
              <div className={styles["load-more-warpper"]}>
                <div className={styles["load-more-container"]}>
                  <button onClick={this.handleLoadMore} className={styles["load-more-button"]} disabled={loading}>
                    {loading ? "Loading..." : "Load More"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

AudioMagazineCollectionListPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
